import { computed } from "vue";
import { useStore } from "vuex";

import type { RootState } from "@/store/types";

export function useUser() {
    const store = useStore<RootState>();

    const isAuthorized = computed(() => store.state.auth.isAuthorized);

    return {
        isAuthorized
    };
}
